module.exports = __webpack_public_path__ + "static/media/storepreviewStoreTwo.d90631f1.svg";